import { Exclude, Expose, Type } from "class-transformer";
import { IsArray, IsDefined, IsInt, IsUUID, ValidateNested } from "class-validator";
import { v4 as uuid } from "uuid";

import { Position } from "./Position";
import { Season } from "./Season";

@Exclude()
export class Waypoint {
    @IsUUID("4")
    @IsDefined()
    @Expose()
    public _id: string = uuid();

    @IsDefined()
    @Expose()
    @Type(() => Position)
    public position: Position;

    @IsInt()
    @IsDefined()
    @Expose()
    public order: number = 0;

    @IsArray()
    @IsDefined()
    @ValidateNested()
    @Expose()
    @Type(() => Season)
    public seasons: Season[] = [];

    public constructor(position: Position, order: number) {
        this.position = position;
        this.order = order;
    }
}
